import { useNavigate } from "react-router-dom";
import {
  getReturnPath,
  clearNavigationSource,
  getNavigationSource,
  shouldRedirectToSource,
} from "@/utils/navigationSource";

/**
 * Custom hook to handle navigation back to the source page
 * (family landing or member detail)
 */
export const useNavigationSource = () => {
  const navigate = useNavigate();

  /**
   * Navigate back to the stored navigation source
   * Falls back to /profile/family if no source is stored
   */
  const navigateBack = () => {
    const returnPath = getReturnPath();
    navigate(returnPath);
  };

  /**
   * Navigate back only if a navigation source exists
   * Returns true if navigated, false if no source exists
   */
  const navigateBackIfExists = (): boolean => {
    if (shouldRedirectToSource()) {
      const returnPath = getReturnPath();
      navigate(returnPath);
      return true;
    }
    return false;
  };

  /**
   * Clear the navigation source
   * Useful when user clicks footer navigation
   */
  const clearSource = () => {
    clearNavigationSource();
  };

  /**
   * Check if navigation source exists
   */
  const hasNavigationSource = (): boolean => {
    return shouldRedirectToSource();
  };

  return {
    navigateBack,
    navigateBackIfExists,
    clearSource,
    getReturnPath,
    hasNavigationSource,
    getNavigationSource,
  };
};
